import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleSubmit } from "../../controller/DiariesLabelController/Controller/CreateDiariesLabelController";
import DiariesLabelController from "../../controller/DiariesLabelController/Controller/DiariesController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSite from "../../../Common/HelpLink";
function CreateDiariesLabel() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ DiariesLable: '', ID: 0 });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);

    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        async function fetchDiairesLable() {
            try {
                debugger;
                const redirectCallback = () => {
                    navigate('/');
                };
                const ClientID = localStorage.getItem('CompanyID');
                const diaireLabel = await DiariesLabelController.GetDiariesLabel(redirectCallback, ClientID);
                setFormData({
                    DiariesLable: diaireLabel[0].DiariesLable,
                    ID: diaireLabel[0].ID
                });
            } catch (error) {
                console.error('Error fetching company setup:', error);
            }
        }
        fetchDiairesLable();
    }, [navigate]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {

        event.preventDefault();
        const redirectCallback = () => {
            navigate('/');
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(formData, setFormData, setErrors, redirectCallback, redirectUserList);
        const updatedCompanySetup = await DiariesLabelController.GetDiariesLabel(redirectCallback, formData.ClientID);
        setFormData(updatedCompanySetup[0] || {});
        window.scrollTo(0, 0);
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Job Diaries" Module="26" />
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>

                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Diaries</label>
                    <div className="col-sm-4">
                        <input type="hidden" className="form-control" name="ID" value={formData.ID} onChange={handleFieldChange} />
                        <input type="text" className="form-control" name="DiariesLable" value={formData.DiariesLable} onChange={handleFieldChange} />
                        {errors.DiariesLable && <div style={{ color: 'red' }}>{errors.DiariesLable}</div>}
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <div className="col-sm-2"></div>
                    <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary">
                            <i className="icofont-save" aria-hidden="true"> Save

                            </i>
                        </button>

                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateDiariesLabel;
